var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('fg-input',{attrs:{"type":"text","value":_vm.value,"placeholder":_vm.placeholder},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }